





















































import Vue from 'vue';
import TooltipInfo from '@/components/dumb/TooltipInfo.vue';
import PriceDisclaimer from '@/components/dumb/PriceDisclaimer.vue';

export default Vue.extend({
	name: 'HeadingColumns', 
	props: {
		items: Array, 
		big: Boolean, 
		loading: Boolean,
		globalSubHeading: String
	}, 
	components: {
		TooltipInfo, 
		PriceDisclaimer
	}, 
	computed: {
		sm(): string {
			return 'auto';
		},
		cols(): string {
			return this.items.length % 4 == 0 ? '6' : 'auto';
		}
	}, 
	methods: {
		isItemOnlyDisclaimer(item: any): boolean {
			return !item.subtext && !item.heading && !item.sup && !item.subHeading && !item.pill
		}, 
		getHeadingColClass(item: any): string {
			const isDis = this.isItemOnlyDisclaimer(item);
			return (this.big ? 'px-8' : 'px-2') + 
				(this.items.length % 4 == 0 ? ' tb-equal' : '') + 
				' tb-heading-column-col' + 
				(isDis ? ' mt-n4 tb-disclaimer-only' : ' mb-4')
			;
		}
	}
});
